import {
  GETLOYALTYPOINTSLIST_SUCCESS,
  GETLOYALTYPOINTSLIST_FAILED,
  RESET_GETLOYALTYPOINTSLIST,
  LOADING_GETLOYALTYPOINTSLIST,
  NETWORK_ERROR_GETLOYALTYPOINTSLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETLOYALTYPOINTSLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETLOYALTYPOINTSLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETLOYALTYPOINTSLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETLOYALTYPOINTSLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETLOYALTYPOINTSLIST:
      return (state = initialState);
    default:
      return state;
  }
};
